<template>
  <div class="ss-g" :class="ctl.isPhone ? 'ss-g1' : 'ss-g2'">
    <div class="ss-gm">
      <set-card id="jezici" :title="$t('settings_shell.language.apps')" :desc="$t('settings_shell.language.apps_d')">
        <div class="ss-fld" :class="{ 'is-changed': ctl.changed('language') }" data-path="language">
          <div class="ss-chips" role="group" :aria-label="$t('settings_shell.language.apps')" translate="no">
            <button
              v-for="[code, name] in languages"
              :key="code"
              type="button"
              class="ui-toggle ss-chip"
              :class="{ 'is-on': selected.includes(code) }"
              :aria-pressed="String(selected.includes(code))"
              :data-code="code"
              @click="toggle(code)"
            >
              <v-icon v-if="selected.includes(code)" size="14">mdi-check</v-icon>
              <span>{{ name }}</span>
              <small v-if="selected[0] === code" class="ss-chip__d">{{ $t("settings_shell.language.default") }}</small>
            </button>
          </div>
          <p class="ss-hint ss-hint--b">
            {{ $t("settings_shell.language.count", { n: selected.length, total: languages.length }) }}
            <template v-if="selected.length"> · {{ $t("settings_shell.language.default_d") }}</template>
          </p>
          <p v-if="ctl.warnText('language')" class="ui-warn">{{ ctl.warnText("language") }}</p>
        </div>
      </set-card>
    </div>
    <aside class="ss-gs ss-gs--n">
      <set-card id="pismo" :title="$t('settings_shell.language.alphabet')" :desc="$t('settings_shell.language.alphabet_d')">
        <ui-segment :value="ctl.alphabet" :options="alphabets" :label="$t('settings_shell.language.alphabet')" @input="ctl.setAlphabet($event)" />
        <p class="ss-sample" translate="no">{{ ctl.alphabet === "cir" ? sampleCir : sampleLat }}</p>
        <p class="ss-note ui-banner ui-banner--info">
          <v-icon size="16">mdi-information-outline</v-icon>
          <span>{{ $t("settings_shell.language.alphabet_note") }}</span>
        </p>
      </set-card>
      <set-card id="valuta" :title="$t('settings_shell.language.currency')">
        <div :class="{ 'is-changed': ctl.changed('price') }" class="ss-fld" data-path="price">
          <ui-segment :value="ctl.val('price') || ''" :options="currencies" :label="$t('select_currency')" @input="ctl.set('price', $event, false)" />
        </div>
        <p class="ss-hint ss-hint--b">{{ $t("settings_shell.language.currency_d") }}</p>
      </set-card>
    </aside>
  </div>
</template>

<script>
import { CURRENCIES, LANGUAGES } from "../settingsRegistry";
import SetCard from "../parts/SetCard.vue";

/** Osnovno › Jezik i valuta: jezici aplikacije (prvi izabrani je podrazumijevani), pismo unosa teksta i valuta. */
export default {
  name: "ScreenLanguage",
  components: { SetCard },
  inject: { ctl: "settingsCtl" },
  data: () => ({
    languages: LANGUAGES,
    sampleLat: "Čorba od povrća, pečena piletina, palačinke",
    sampleCir: "Чорба од поврћа, пећена пилетина, палачинке",
  }),
  computed: {
    selected() {
      return this.ctl.val("language") || [];
    },
    alphabets() {
      return [
        { value: "lat", label: "Lat" },
        { value: "cir", label: "Ћир" },
      ];
    },
    currencies() {
      return CURRENCIES.map((code) => ({ value: code, label: code }));
    },
  },
  methods: {
    toggle(code) {
      const next = this.selected.slice();
      const index = next.indexOf(code);
      if (index >= 0) {
        next.splice(index, 1);
      } else {
        next.push(code);
      }
      this.ctl.set("language", next);
    },
  },
};
</script>
